import { LocationInfo } from './../../shared/types/location'
import {
    ADD_CHARGER,
    DELETE_CHARGER,
    EDIT_CHARGER,
    FETCH_LOCATION_FOR_DETAIL,
    ADD_LOCATION,
    EDIT_LOCATION,
    DELETE_LOCATION,
    UPLOAD_LOCATION_PHOTOS,
    DELETE_LOCATION_PHOTO,
    UPLOAD_CHARGER_PHOTOS,
    DELETE_CHARGER_PHOTO,
    UPDATE_CONNECTOR_AVAILABILITY,
    STOP_CHARGING,
    START_CHARGING,
    UPDATE_LOCATION_WHITELIST,
    RESET_START_CHARGING_STATE,
    RESET_STOP_CHARGING_STATE,
    CHANGE_CHARGER_CONFIGURATION,
    FETCH_CHARGER_CONFIGURATION,
    RESET_CHARGER_CONFIGURATION_STATE,
    UPDATE_LOCATION_FLEXICHARGING,
    UPDATE_LOCATION_INFO,
} from './../const/index'
import { Image } from '../../shared/types/common'
import { ChargerConnectorState } from '../../shared/types/charger'
import { ChargingSession, ChargingSessionState } from '../../shared/types/chargingSession'

export const locationChargersReducer =
    () =>
    (state = { chargers: new Array<any>() }, action: any) => {
        switch (action.type) {
            case `${FETCH_LOCATION_FOR_DETAIL}_SUCCESS`: {
                return {
                    locationId: action.payload.result.id,
                    chargers: action.payload.result.chargers.map((x: any) => {
                        return {
                            ...x,
                        }
                    }),
                }
            }
            case `${ADD_CHARGER}_SUCCESS`: {
                return {
                    ...state,
                    chargers: [...state.chargers, action.payload.result],
                }
            }
            case `${DELETE_CHARGER}_SUCCESS`: {
                return {
                    ...state,
                    chargers: state.chargers.filter((x) => x.id !== action.payload.chargerId),
                }
            }
            case `${EDIT_CHARGER}_SUCCESS`: {
                return {
                    ...state,
                    chargers: state.chargers.map((x) =>
                        x.id === action.payload.result.id ? action.payload.result : x
                    ),
                }
            }
            case `${UPLOAD_CHARGER_PHOTOS}_SUCCESS`: {
                return {
                    ...state,
                    chargers: state.chargers.map((x) => {
                        if (x.id === action.payload.chargerId) {
                            x.images = x.images.concat(action.payload.result)
                        }
                        return x
                    }),
                }
            }
            case `${DELETE_CHARGER_PHOTO}_SUCCESS`: {
                return {
                    ...state,
                    chargers: state.chargers.map((x) => {
                        if (x.id === action.payload.chargerId) {
                            x.images = x.images.filter((image: Image) => image.id !== action.payload.photoId)
                        }
                        return x
                    }),
                }
            }
            default: {
                return state
            }
        }
    }

export const locationsUpdateReducer = (state: any, action: any) => {
    switch (action.type) {
        case `${ADD_LOCATION}_SUCCESS`: {
            return {
                ...state,
                value: state.value.concat([action.payload.result]),
            }
        }
        case `${EDIT_LOCATION}_SUCCESS`: {
            return {
                ...state,
                value: state.value.map((x: LocationInfo) =>
                    x.id === action.payload.result.id ? { ...x, ...action.payload.result } : x
                ),
            }
        }
        case `${DELETE_LOCATION}_SUCCESS`: {
            return {
                ...state,
                value: state.value.filter((x: LocationInfo) => x.id !== action.payload.locationId),
            }
        }
        case `${UPLOAD_LOCATION_PHOTOS}_SUCCESS`: {
            if (!state.value) return state
            return {
                ...state,
                value: state.value.map((x: LocationInfo) =>
                    x.id === action.payload.locationId ? { ...x, images: x.images.concat(action.payload.result) } : x
                ),
            }
        }
        case `${DELETE_LOCATION_PHOTO}_SUCCESS`: {
            if (!state.value) return state
            return {
                ...state,
                value: state.value.map((x: LocationInfo) =>
                    x.id === action.payload.locationId
                        ? { ...x, images: x.images.filter((y) => y.id !== action.payload.photoId) }
                        : x
                ),
            }
        }
        case `${START_CHARGING}_SUCCESS`: {
            return {
                ...state,
                value: state.value.map((location: LocationInfo) =>
                    location.id === action.payload.result.locationId
                        ? {
                              ...location,
                              availableConnectors: Math.max(0, (location.availableConnectors || 0) - 1),
                              chargingSessionsInProgressCount: (location.chargingSessionsInProgressCount || 0) + 1,
                          }
                        : location
                ),
            }
        }
        case `${STOP_CHARGING}_SUCCESS`: {
            const locationId = action.payload.result?.locationId
            if (!locationId) return state
            return {
                ...state,
                value: state.value.map((location: LocationInfo) =>
                    location.id === locationId
                        ? {
                              ...location,
                              availableConnectors: (location.availableConnectors || 0) + 1,
                              chargingSessionsInProgressCount: Math.max(
                                  0,
                                  (location.chargingSessionsInProgressCount || 0) - 1
                              ),
                          }
                        : location
                ),
            }
        }
        case `${UPDATE_LOCATION_INFO}`: {
            if (!state.value || state.value.length === 0) {
                return state
            }
            return {
                ...state,
                value: state.value.map((location: LocationInfo) =>
                    location.id === action.payload.locationInfo.Id
                        ? {
                              ...location,
                              availableConnectors: action.payload.locationInfo.AvailableConnectors,
                              workingConnectors: action.payload.locationInfo.WorkingConnectors,
                              connectedChargers: action.payload.locationInfo.ConnectedChargers,
                              connectorCount: action.payload.locationInfo.ConnectorCount,
                          }
                        : location
                ),
            }
        }
        default:
            return state
    }
}

export const locationDetailUpdateReducer = (state: any, action: any) => {
    switch (action.type) {
        case `${UPLOAD_LOCATION_PHOTOS}_SUCCESS`: {
            if (!state.value) return state
            return {
                ...state,
                value:
                    state.value.id === action.payload.locationId
                        ? { ...state.value, images: state.value.images.concat(action.payload.result) }
                        : state.value,
            }
        }
        case `${DELETE_LOCATION_PHOTO}_SUCCESS`: {
            if (!state.value) return state
            return {
                ...state,
                value:
                    state.value.id === action.payload.locationId
                        ? {
                              ...state.value,
                              images: state.value.images.filter((y: any) => y.id !== action.payload.photoId),
                          }
                        : state.value,
            }
        }
        case `${UPDATE_CONNECTOR_AVAILABILITY}`: {
            if (!state.value || !state.value.chargers) {
                return state
            }
            return {
                ...state,
                value: {
                    ...state.value,
                    chargers: state.value.chargers.map((charger: any) => {
                        if (charger.id === action.payload.value.chargerId) {
                            return {
                                ...charger,
                                connectors: charger.connectors.map((connector: any) => {
                                    if (connector.id === action.payload.value.connectorId) {
                                        return {
                                            ...connector,
                                            availability: action.payload.value.availType,
                                        }
                                    }
                                    return connector
                                }),
                            }
                        }
                        return charger
                    }),
                },
            }
        }
        case `${EDIT_LOCATION}_SUCCESS`: {
            if (!state.value) {
                return state
            }
            return {
                ...state,
                value: state.value.id === action.payload.result.id ? state.value : null,
            }
        }
        case `${STOP_CHARGING}_SUCCESS`: {
            if (!state.value) {
                return state
            }
            console.log(action.payload.result)

            const sessionId = action.payload.result?.id
            return {
                ...state,
                value: {
                    ...state.value,
                    currentSessions: (state.value.currentSessions || []).filter(
                        (session: ChargingSession) => session.id !== sessionId
                    ),
                },
            }
        }
        case `${START_CHARGING}_SUCCESS`: {
            if (!state.value) {
                return state
            }

            const newSession = action.payload.result
            const chargerId = newSession.charger.id
            const connectorId = newSession.chargingConnector.id

            return {
                ...state,
                value: {
                    ...state.value,
                    // Update currentSessions
                    currentSessions: [
                        ...(state.value.currentSessions?.filter(
                            (session: ChargingSession) =>
                                !(
                                    session.chargingConnectorId === null &&
                                    session.idTag === newSession.idTag &&
                                    session.state === ChargingSessionState.InProgress
                                )
                        ) || []),
                        newSession,
                    ],
                    // Update chargers and their connectors
                    chargers: (state.value.chargers || []).map((charger: any) => {
                        if (charger.id === chargerId) {
                            return {
                                ...charger,
                                connectors: (charger.connectors || []).map((connector: any) => {
                                    if (connector.id === connectorId) {
                                        return {
                                            ...connector,
                                            ocppStatus: 'Charging',
                                            state: ChargerConnectorState.Busy,
                                        }
                                    }
                                    return connector
                                }),
                            }
                        }
                        return charger
                    }),
                },
            }
        }
        case `${UPDATE_LOCATION_WHITELIST}_SUCCESS`: {
            if (!state.value) {
                return state
            }
            return {
                ...state,
                value: {
                    ...state.value,
                    whitelist: action.payload.result,
                },
            }
        }
        case `${UPDATE_LOCATION_FLEXICHARGING}_SUCCESS`: {
            if (!state.value) {
                return state
            }

            // action.payload.result je pravdepodobne uložená lokalita vrátená z BE
            const updatedLocation = action.payload.result

            return {
                ...state,
                // Ak uložená lokalita má rovnaké ID ako tá v state, nahradíme ju novými dátami
                value: state.value.id === updatedLocation.id ? updatedLocation : state.value,
            }
        }
        case RESET_STOP_CHARGING_STATE:
        case RESET_START_CHARGING_STATE: {
            return {
                ...state,
                executed: false,
                error: null,
            }
        }
        default:
            return state
    }
}

export const chargerConfigurationItemsReducer = (state: any = { value: [] }, action: any) => {
    switch (action.type) {
        case `${FETCH_CHARGER_CONFIGURATION}_SUCCESS`: {
            return {
                ...state,
                value: action.payload.result,
            }
        }
        default:
            return state
    }
}

export const chargerConfigurationUpdateReducer = (state: any = { executed: false }, action: any) => {
    switch (action.type) {
        case `${CHANGE_CHARGER_CONFIGURATION}_SUCCESS`: {
            return {
                ...state,
                executed: true,
                value: action.payload.result,
            }
        }
        case RESET_CHARGER_CONFIGURATION_STATE: {
            return {
                executed: false,
                error: null,
                value: [],
            }
        }
        default:
            return state
    }
}

export const locationSelectedIdUpdateReducer = (state: any, action: any) => {
    switch (action.type) {
        case `${DELETE_LOCATION}_SUCCESS`: {
            if (state.value === action.payload.locationId) {
                return {
                    ...state,
                    value: null,
                }
            } else {
                return state
            }
        }
        default:
            return state
    }
}

// 1. Doplň coverImage aj do synchu z detailu
const updateLocationStatsFromDetail = (locationInList: LocationInfo, detail: any) => {
    if (!detail || locationInList.id !== detail.id) {
        return locationInList
    }

    return {
        ...locationInList,
        connectorCount: detail.connectorCount ?? locationInList.connectorCount,
        workingConnectors: detail.workingConnectors ?? locationInList.workingConnectors,
        availableConnectors: detail.availableConnectors ?? locationInList.availableConnectors,
        chargingSessionsInProgressCount:
            detail.chargingSessionsInProgressCount ?? locationInList.chargingSessionsInProgressCount,
        chargingSessionsCount: detail.chargingSessionsCount ?? locationInList.chargingSessionsCount,
        images: detail.images ?? locationInList.images,
        coverImage: detail.coverImage ?? locationInList.coverImage, // 👈 Pridaný coverImage
    }
}

// 2. Samotný Wrapper Reducer
export const locationsItemsWithDetailUpdateReducer = (asyncLocationsReducer: any) => {
    return (state: any, action: any) => {
        const nextState = asyncLocationsReducer(state, action)
        const locationsList = nextState?.value || state?.value

        if (!Array.isArray(locationsList)) {
            return nextState
        }

        // 🔄 A) REFRESH CEZ DETAIL
        if (action.type === `${FETCH_LOCATION_FOR_DETAIL}_SUCCESS` && action.payload?.result) {
            const detail = action.payload.result
            return {
                ...nextState,
                value: locationsList.map((location: LocationInfo) =>
                    location.id === detail.id ? updateLocationStatsFromDetail(location, detail) : location
                ),
            }
        }

        // 📸 B) NAHRATIE FOTKY (UPLOAD)
        if (action.type === `${UPLOAD_LOCATION_PHOTOS}_SUCCESS` && action.payload) {
            const { locationId, result } = action.payload

            return {
                ...nextState,
                value: locationsList.map((location: LocationInfo) => {
                    if (location.id !== locationId) return location

                    const currentImages = location.images || []
                    const uploadedImages = Array.isArray(result) ? result : [result]
                    const updatedImages = [...currentImages, ...uploadedImages]

                    // 💡 Ak náhľadový obrázok chýba, nastavíme ako coverImage prvú novú fotku
                    const newCoverImage = location.coverImage ? location.coverImage : uploadedImages[0] || null

                    return {
                        ...location,
                        images: updatedImages,
                        coverImage: newCoverImage, // 👈 Automaticky vyplní coverImage
                    }
                }),
            }
        }

        // 🗑️ C) ZMAZANIE FOTKY (DELETE)
        if (action.type === `${DELETE_LOCATION_PHOTO}_SUCCESS` && action.payload) {
            const { locationId, photoId } = action.payload

            return {
                ...nextState,
                value: locationsList.map((location: LocationInfo) => {
                    if (location.id !== locationId) return location

                    const currentImages = location.images || []
                    const updatedImages = currentImages.filter((img: any) => img.id !== photoId)

                    // 💡 Ak sme zmazali fotku, ktorá bola coverImage, doplň do coverImage 1. fotku zo zvyšných
                    const isCoverDeleted = location.coverImage?.id === photoId
                    const newCoverImage = isCoverDeleted ? updatedImages[0] || null : location.coverImage

                    return {
                        ...location,
                        images: updatedImages,
                        coverImage: newCoverImage, // 👈 Ošetrené zmazanie titulky
                    }
                }),
            }
        }

        return nextState
    }
}
